import React, {useState} from 'react';
import EtCelebrateResultIconSVGComp from "@/assets/img/icons/svgComp/EtCelebrateResultIcon1SVGComp";

// 18 Apr 2025
import {
  useGetUserPerformanceLogsQuery,
  useCreateNewUserPerformanceLogMutation,
} from '@/features/userPerformanceLogs/userPerformanceLogsApiSlice';

import {
  PlusIcon,
  MinusIcon,
  TrashIcon,
  PencilSquareIcon,
} from "@heroicons/react/24/outline"

import { 
  ClockIcon, 
  CalendarDaysIcon, 
  UserGroupIcon,
  ArrowPathIcon,
  DocumentTextIcon,
  ArrowTrendingUpIcon,
  ShareIcon 
} from "@heroicons/react/24/solid"

import PulseLoader from "react-spinners/PulseLoader"

import moment from 'moment';
import { isInSelectedTimePeriod } from "@/utils/timeUtils";

// 24 Jun 2025
import EtPerformanceCard from "@/components/performance/EtPerformanceCard"
import { createSvgComponentFromBase64 } from '@/utils/createSvgComponentFromBase64' 

import EtImprintMissionsIcon1SVGComp from '@/assets/img/icons/svgComp/EtImprintMissionsIcon1SVGComp'
import EtImprintMissionsSelfIcon1SVGComp from '@/assets/img/icons/svgComp/EtImprintMissionsSelfIcon1SVGComp'
import EtImprintMissionsClientsIcon1SVGComp from '@/assets/img/icons/svgComp/EtImprintMissionsClientsIcon1SVGComp'
import EtImprintMissionOrgIcon1SVGComp from '@/assets/img/icons/svgComp/EtImprintMissionOrgIcon1SVGComp'
import EtImprintMissionPartnerIcon1SVGComp from '@/assets/img/icons/svgComp/EtImprintMissionPartnerIcon1SVGComp'
import EtImprintMissionTeamIcon1SVGComp from '@/assets/img/icons/svgComp/EtImprintMissionTeamIcon1SVGComp'

import EtImprintMissionsIcon2SVGComp from '@/assets/img/icons/svgComp/EtImprintMissionsIcon2SVGComp'

const EtTrinityMissionPerformance = ({ userId="",userOrgId="", onClose }) => {
 
  // First Created - 23 May 2025
  // Author - Atul Pandey
  // Purpose - Prompt user to evaluate mission performance
  // Updated - 23 Jun 2025 - Added the main logic - inherited from EtTrinityWebCelebratePerformanceLog component
  // Updated - 24 Jun 2025 - Refined the display JSX for all tabs
  // Updated - 01 Sep 2025 - refined to check for sharedMissionId

  // 1a - State Variables
    const [activeTab, setActiveTab] = useState('overall');  
    const [activePeriod, setActivePeriod] = useState('today'); 
    const [selectedTrailTab, setSelectedTrailTab] = useState('overview');
    const [selectedMissionFocusTab, setSelectedMissionFocusTab] = useState('overview');
    const [showSessionPerf, setShowSessionPerf] = useState({}) // 24 Jun 2025
    const [showMissionPerf, setShowMissionPerf] = useState({}) // 24 Jun 2025
  
  
    // 2a - Data - RTK Queries & Mutations
    const {
      data: performanceLogsData,
      isLoading,
      isError,
      error,
      refetch,
    } = useGetUserPerformanceLogsQuery(userId);
  
    const [createNewPerformanceLog, { isLoading: isCreating }] = useCreateNewUserPerformanceLogMutation();

  // 2c - Define the logs
  const allLogs = performanceLogsData?.ids?.map(id => performanceLogsData.entities[id]) || [];
  const logs = allLogs.filter(log => isInSelectedTimePeriod(log.createdAt, activePeriod))[0];

  // console.log('all logs', allLogs)
  // console.log('logs', logs)

  // 3a - Handle Toggle showSessionPerf
    const handleToggleShowSessionPerf = (sessionId) => {
      setShowSessionPerf((prev) => ({
        ...prev,
        [sessionId]: !prev[sessionId],
      }));
    };

  // 3b - Handle Toggle showMissionPerf
    const handleToggleShowMissionPerf = (missionId) => {
      setShowMissionPerf((prev) => ({
        ...prev,
        [missionId]: !prev[missionId],
      }));
    };

  
  return (
    <div className="p-4 w-full max-w-6xl mx-auto font-poppins">
      <div className='flex justify-between items-center'>
          <h3 className="text-lg font-bold text-gray-800 mb-2">Your Mission Performance</h3>
            
          <button
            onClick={onClose}
            className="mt-4 text-sm text-blue-600 underline"
          >
            Close
          </button>
      </div>

      <div className='font-poppins'>
      <div className='m-1 p-1 border-b-4 border-orange-600'>
        <div className='flex justify-start items-center'>
            <div className='flex justify-center items-center w-10 h-10 rounded-full bg-gradient-to-r from-orange-600 to-orange-600 via-orange-800 hover:bg-gradient-to-r hover:from-orange-400 hover:via-orange-600 hover:to-black cursor-pointer shadow-md'>
                <EtCelebrateResultIconSVGComp className="h-7 w-7 text-white" />
            </div>
            <div className='mx-1 px-1 pb-2'>
                {/* <p className="text-md sm:text-xl font-semibold mb-1">Performance Log – The Results</p>
                <p className="text-[10px] sm:text-[13px] text-gray-500">Results from your efforts, categorized by Missions.</p> */}
                <p className="text-md sm:text-lg xl:text-xl font-bold xl:font-semibold mb-1">Performance Log – The Results</p>
                <p className="text-[10px] sm:text-[12px] xl:text-[13px] text-gray-500">See what mission peaks your efforts lit up!</p>
            </div>
        </div>
    </div>
   
    
    {/* Refresh & Tabs */}
    <div className="flex justify-start space-x-4 border-b border-orange-300 mb-4 mt-2">
      {/* Refresh button */}            
      <div className="flex justify-start items-center px-3 py-1"
          onClick={async () => {
            try {
              await createNewPerformanceLog({ userId, userOrgId }).unwrap();
              refetch();
            } catch (err) {
              console.error('Failed to create performance log:', err);
            }
          }}
          disabled={isCreating}
      >
            {isCreating ? (
              <div className='bg-orange-600 p-1 flex justify-start items-center w-48 rounded'>
                <p className='text-white mx-1 px-1'>Syncing</p>
                <PulseLoader color={"#fff"} />
              </div>  
            ) : (
            
              <div className="h-5 w-5 flex justify-center items-center rounded-full bg-gradient-to-r from-orange-600 to-orange-600 via-orange-800 hover:bg-gradient-to-r hover:from-orange-400 hover:via-orange-600 hover:to-black cursor-pointer shadow-md">
                <ArrowPathIcon className="h-4 w-4 text-white" />
              </div>
          )}    
      </div>
      
      {/* Tabs */}
      {['overall', 'induction', 'mymissions'].map(tab => (
        <button
          key={tab}
          className={`text-sm font-semibold px-1 xl:px-3 py-1 rounded-t ${
            activeTab === tab ? 'bg-orange-200 text-orange-800' : 'text-gray-500'
          }`}
          onClick={() => setActiveTab(tab)}
        >
          {tab === 'overall' && 'Overall'}
          {tab === 'induction' && 'Induction'}
          {tab === 'mymissions' && 'MyMissions'}
        </button>
      ))}
    </div>

    {/* Time Filter Chips */}
    <div className="flex flex-wrap gap-1 xl:gap-2 mb-3 text-[9px] xl:text-xs font-semibold">
      {['today', 'week', 'month', 'quarter', 'year'].map(period => (
        <button
          key={period}
          className={`px-2 py-1 rounded-full border ${
            activePeriod === period
              ? 'bg-orange-600 text-white'
              : 'bg-gray-100 text-gray-600'
          }`}
          onClick={() => setActivePeriod(period)}
        >
          {period === 'today' && 'Today'}
          {period === 'week' && 'This Week'}
          {period === 'month' && 'This Month'}
          {period === 'quarter' && 'This Qtr'}
          {period === 'year' && 'This Year'}
        </button>
      ))}
    </div>

      {activeTab === 'overall' && (
        <div className="space-y-1 mt-2 overflow-y-auto max-h-[70vh] rounded bg-gray-200 m-1 p-1 shadow-lg shadow-black">
          <div className="bg-white rounded shadow border border-orange-300 p-4">
            {/* <div className="flex justify-between items-center mb-3"> */}
            <div className="mb-3 pb-2 border-b">
              <h3 className="text-lg font-bold text-orange-800">Your Overall Performance</h3>
              <div className="flex justify-start items-center gap-2 py-1">
                <p className="text-xs text-gray-600">Category:</p>
                <div className="flex justify-center items-center bg-orange-200 px-2 py-[2px] rounded-full text-xs font-semibold text-orange-800">
                  Actions
                </div>
              </div>
            </div>

            <EtPerformanceCard
              total={logs?.overallPerformance?.totalActions ?? 0}
              completed={logs?.overallPerformance?.completedActions ?? 0}
              rate={logs?.overallPerformance?.completionRate ?? 0}
            />
          </div>
        </div>
      
      )}

      {activeTab === 'induction' && (() => {
        
        const trails = logs?.inductionPerformance?.trails || [];
        const selectedTrail = trails.find(t => t?.trailId?._id === selectedTrailTab);

        return (
          <div className="space-y-1 mt-2 overflow-y-auto max-h-[70vh] rounded bg-gray-200 m-1 p-1 shadow-lg shadow-black">

            {/* Tab Bar */}
           <div className="flex space-x-4 border-b border-orange-500 mb-4 overflow-x-auto">
              <button
                onClick={() => setSelectedTrailTab('overview')}
                className={`flex items-center space-x-2 px-4 py-2 text-sm font-semibold border-b-2 ${
                  selectedTrailTab === 'overview'
                    ? "border-orange-600 text-orange-600"
                    : "border-transparent text-gray-500"
                }`}
              >
                <div
                  className={`h-8 w-8 flex justify-center items-center rounded-full cursor-pointer ${
                    selectedTrailTab === 'overview'
                      ? "bg-gradient-to-r from-orange-600 to-orange-600 via-orange-800 hover:from-orange-400 hover:via-orange-600 hover:to-black shadow-lg shadow-black"
                      : "bg-gray-50 hover:bg-white"
                  }`}
                >
                  <ArrowTrendingUpIcon className={`h-5 w-5 ${selectedTrailTab === 'overview' ? "text-white" : "text-orange-600"}`} />
                </div>
                <span>Overview</span>
              </button>

              {trails.map((trail, index) => {

                const MyIcon = createSvgComponentFromBase64(trail?.trailId?.pic)

                // console.log('Base64 SVG:', trail?.trailId?.pic?.slice(0, 50));
                
                return(
                  <div >
                    <button
                      key={trail.trailId?._id+index}
                      onClick={() => setSelectedTrailTab(trail.trailId?._id)}
                      className={`flex items-center space-x-2 px-4 py-2 text-sm font-semibold border-b-2 ${
                        selectedTrailTab === trail.trailId?._id
                          ? "border-orange-600 text-orange-600"
                          : "border-transparent text-gray-500"
                      }`}
                    >
                      <div
                        className={`h-8 w-8 rounded-full flex justify-center items-center cursor-pointer overflow-hidden ${
                          selectedTrailTab === trail.trailId?._id
                            ? "bg-gradient-to-r from-orange-600 to-orange-600 via-orange-800 hover:from-orange-400 hover:via-orange-600 hover:to-black shadow-lg shadow-black"
                            : "bg-gray-50 hover:bg-white"
                        }`}
                      >
                        {/* <MyIcon className="h-5 w-5" /> */}
                        <MyIcon
                          className={`h-7 w-7 ${
                            selectedTrailTab === trail?.trailId?._id
                              ? 'text-white'
                              : 'text-orange-600'
                          }`}
                        />
                      </div>
                      <span>{trail?.trailId?.trailName}</span>
                    </button>
                </div>
              )})}
            </div>
            
            {/* Content: Overview or Selected Trail */}
            {selectedTrailTab === 'overview' ? (
              <div className="bg-white rounded shadow border border-orange-400 p-4">
                <div className="mb-2 pb-2 border-b">
                  <h3 className="text-md font-bold text-orange-800">Induction Trail Performance</h3>
                  <p className="text-xs text-gray-500">Across all <span className='text-gray-800 font-bold rounded-full px-1 bg-orange-100'>Induction</span> trails and sessions</p>
                </div>

                <EtPerformanceCard
                  total={logs?.inductionPerformance?.totalActions ?? 0}
                  completed={logs?.inductionPerformance?.completedActions ?? 0}
                  rate={logs?.inductionPerformance?.completionRate ?? 0}
                />
              </div>
            ) : (
              <div key={selectedTrail?.trailId?._id} className="bg-white rounded shadow border border-orange-400 p-4">

                <div className="mb-2 pb-2 border-b">
                  <h3 className="text-md font-bold text-orange-800">{selectedTrail?.trailId?.trailName} Trail Performance</h3>
                  <p className="text-xs text-gray-500">Across all <span className='text-gray-800 font-bold rounded-full px-1 bg-orange-100'>{selectedTrail?.trailId?.trailName}</span> trail sessions</p>
                </div>

                <EtPerformanceCard
                  total={selectedTrail?.totalActions ?? 0}
                  completed={selectedTrail?.completedActions ?? 0}
                  rate={selectedTrail?.completionRate ?? 0}
                />

                {/* Session Breakdown */}
                {selectedTrail?.sessions?.length > 0 && (
                  <div className=''>
                    <div className='bg-orange-100 rounded my-1 py-1'>
                      <p className='font-bold text-orange-800 mx-1 px-1 py-2'>Session Performance</p>
                    </div>

                    {selectedTrail?.sessions?.map((session,sIndex) => {
                      const sessionId = session?.sessionId?._id || null
                      const sessionName = session?.sessionId?.sessionName || ""
                      const sessionPic = session?.sessionId?.pic || ""
                      const total = session?.totalActions || 0
                      const completed = session?.completedActions || 0
                      const rate = session?.completionRate || 0
                      const MySessionIcon = createSvgComponentFromBase64(sessionPic)

                      // console.log('session', session)
                      return(
                        <div key={sessionId+sIndex} className='bg-gray-100 border rounded my-1 py-1'>
                          <div className='flex justify-start items-center m-1 p-1'>
                            <div
                              onClick={() =>handleToggleShowSessionPerf(sessionId)}
                              className="mx-2 cursor-pointer rounded-full h-5 w-5 flex justify-center items-center hover:bg-white"
                            >
                              {showSessionPerf[sessionId] ? (
                                  <MinusIcon className="h-4 w-4 text-orange-600" />
                              ) : (
                                  <PlusIcon className="h-4 w-4 text-orange-600" />
                              )}
                            </div>
                            <p className='text-lg font-bold mx-1 px-1'>{sIndex+1}.</p>
                            <div
                              className={`h-6 w-6 rounded-full flex justify-center items-center cursor-pointer bg-white`}
                            >
                              <MySessionIcon
                                className={`h-5 w-5 ${
                                  showSessionPerf[sessionId]
                                    ? 'text-white'
                                    : 'text-orange-600'
                                }`}
                              />
                            </div>
                            <p className='mx-1 px-1'>{sessionName}</p>
                          </div>

                          {showSessionPerf[sessionId] && (
                            <div className='bg-white rounded m-1 p-1'>
                              <EtPerformanceCard
                                total={total ?? 0}
                                completed={completed ?? 0}
                                rate={rate ?? 0}
                              />
                            </div>
                          )}
                          


                        </div>
                      )
                    })}
                  </div>
                )}
              </div>
            )}
          </div>
        );
      })()}


      {activeTab === 'mymissions' && (() => {
        const focusAreas = [
          { key: 'overview', label: 'Overview', Icon: EtImprintMissionsIcon1SVGComp },
          { key: 'self', label: 'Self', Icon: EtImprintMissionsSelfIcon1SVGComp },
          { key: 'client', label: 'Client', Icon: EtImprintMissionsClientsIcon1SVGComp },
          { key: 'org', label: 'Org', Icon: EtImprintMissionOrgIcon1SVGComp },
          { key: 'team', label: 'Team', Icon: EtImprintMissionTeamIcon1SVGComp },
          { key: 'partner', label: 'Partner', Icon: EtImprintMissionPartnerIcon1SVGComp }
        ];
        
        const selectedFocus = selectedMissionFocusTab; // assume state: selectedMissionFocusTab / setSelectedMissionFocusTab
        const isOverview = selectedFocus === 'overview';

        return (
          <div className="space-y-1 mt-2 overflow-y-auto max-h-[70vh] rounded bg-gray-200 m-1 p-1 shadow-lg shadow-black">
            
            {/* 🔸 Tabs */}
            <div className="flex space-x-4 border-b border-orange-500 mb-4 overflow-x-auto">
              {focusAreas.map(({ key, label, Icon }) => (
                <button
                  key={key}
                  onClick={() => setSelectedMissionFocusTab(key)}
                  className={`flex items-center space-x-2 px-4 py-2 text-sm font-semibold border-b-2 ${
                    selectedFocus === key
                      ? "border-orange-600 text-orange-600"
                      : "border-transparent text-gray-500"
                  }`}
                >
                  <div
                    className={`h-8 w-8 flex justify-center items-center rounded-full cursor-pointer ${
                      selectedFocus === key
                        ? "bg-gradient-to-r from-orange-600 to-orange-600 via-orange-800 hover:from-orange-400 hover:via-orange-600 hover:to-black shadow-lg shadow-black"
                        : "bg-gray-50 hover:bg-white"
                    }`}
                  >
                    <Icon className={`h-5 w-5 ${selectedFocus === key ? "text-white" : "text-orange-600"}`} />
                  </div>
                  <span>{label}</span>
                </button>
              ))}

            </div>

            {/* 🔸 Overview or Focus Area Content */}
            {isOverview ? (
              <>
                {/* Overview Card */}
                <div className="bg-white rounded shadow border border-orange-400 p-4 mb-2">
                  <div className="mb-2 pb-2 border-b">
                    <h3 className="text-md font-bold text-orange-800">MyMissions Performance</h3>
                    <p className="text-xs text-gray-500">Across all focus areas and plans</p>
                  </div>
                  <EtPerformanceCard
                    total={logs?.myMissionsPerformance?.totalActions ?? 0}
                    completed={logs?.myMissionsPerformance?.completedActions ?? 0}
                    rate={logs?.myMissionsPerformance?.completionRate ?? 0}
                  />
                </div>
              </>
            ) : (
              <>
                {/* Focus-wise breakdown for selected tab only */}
                {(() => {
                  const focus = logs?.myMissionsPerformance?.[selectedFocus];
                  if (!focus || focus.totalActions === 0) return null;

                  return (
                    <div key={selectedFocus} className="bg-white rounded shadow border border-orange-400 p-4 mb-2">

                      <div className="mb-2 pb-2 border-b">
                        <h3 className="text-md font-bold text-orange-800"><span className='capitalize'>{selectedFocus}</span> Mission Performance</h3>
                        <p className="text-xs text-gray-500">Across all <span className='text-gray-800 font-bold rounded-full px-1 bg-orange-100'>{selectedFocus}</span> mission plans</p>
                      </div>
                      <EtPerformanceCard
                        total={focus?.totalActions ?? 0}
                        completed={focus?.completedActions ?? 0}
                        rate={focus?.completionRate ?? 0}
                      />

                      {/* Mission/Plan Breakdown */}
                      {focus.missions?.length > 0 && (

                        <div className=''>
                          <div className='bg-orange-100 rounded my-1 py-1'>
                            <p className='font-bold text-orange-800 mx-1 px-1 py-2'>Mission Performance</p>
                          </div>

                          {focus.missions?.map((mission,mIndex) => {

                            // console.log('mission inside focus.missions', mission) // Debug 01 Sep 2025

                            // 01 Sep 2025 - refined to check for sharedMissionId

                            const missionId = mission?.missionId?.sharedMissionId ? mission?.missionId?.sharedMissionId?._id : mission?.missionId?._id || null
                            const missionName = mission?.missionId?.sharedMissionId ? mission?.missionId?.sharedMissionId?.missionName : mission?.missionId?.missionName || ""
                            const missionDesc = mission?.missionId?.sharedMissionId ? mission?.missionId?.sharedMissionId?.missionDesc : mission?.missionId?.missionDesc || ""
                            const missionTarget = mission?.missionId?.sharedMissionId ? mission?.missionId?.sharedMissionId?.mission1YrTargetValue: mission?.missionId?.mission1YrTargetValue || 0
                            const targetDate = mission?.missionId?.sharedMissionId ? mission?.missionId?.sharedMissionId?.mission1YrTargetDate : mission?.missionId?.mission1YrTargetDate || ""
                            const targetUoM = mission?.missionId?.sharedMissionId ? mission?.missionId?.sharedMissionId?.missionUoMType?.missionMetricUoMTypeName : mission?.missionId?.missionUoMType?.missionMetricUoMTypeName || ""
                            const targetGradation = mission?.missionId?.sharedMissionId ? mission?.missionId?.sharedMissionId?.missionGradationType?.missionMetricGradationTypeName : mission?.missionId?.missionGradationType?.missionMetricGradationTypeName || ""
                            const total = mission?.missionId?.sharedMissionId ? mission?.missionId?.sharedMissionId?.totalActions : mission?.totalActions || 0
                            const completed = mission?.missionId?.sharedMissionId ? mission?.missionId?.sharedMissionId?.completedActions : mission?.completedActions || 0
                            const rate = mission?.missionId?.sharedMissionId ? mission?.missionId?.sharedMissionId?.completionRate : mission?.completionRate || 0

                            console.log('mission', mission)
                            return(
                              <div key={missionId+mIndex} className='bg-gray-100 border rounded my-1 py-1'>
                                
                                <div className='grid grid-cols-6 justify-between items-center m-1 p-1'>
                                  <div className='col-span-3 flex justify-start items-center'>
                                    <div
                                      onClick={() =>handleToggleShowMissionPerf(missionId)}
                                      className="mx-2 cursor-pointer rounded-full h-5 w-5 flex justify-center items-center hover:bg-white"
                                    >
                                      {showMissionPerf[missionId] ? (
                                          <MinusIcon className="h-4 w-4 text-orange-600" />
                                      ) : (
                                          <PlusIcon className="h-4 w-4 text-orange-600" />
                                      )}
                                    </div>
                                    <p className='text-lg font-bold mx-1 px-1'>{mIndex+1}.</p>
                                    <div
                                      className={`h-8 w-8 rounded-full flex justify-center items-center cursor-pointer bg-white`}
                                    >
                                      <EtImprintMissionsIcon2SVGComp className="h-6 w-6 text-orange-600"
                                      />
                                    </div>
                                    <p className='mx-1 px-1'>{missionName}</p>
                                  </div>
                                  <div className='col-span-1 flex justify-start items-center'>
                                    <p className='text-orange-800 text-xs mx-1'>Metric:</p>
                                    <p className='text-gray-800 font-bold text-xs mx-1 px-1 rounded-full bg-orange-100'>{targetUoM}</p>
                                  </div>
                                  <div className='col-span-1 flex justify-start items-center'>
                                    <p className='text-orange-800 text-xs mx-1'>Target:</p>
                                    <p className='text-gray-800 font-bold text-xs mx-1 px-1 rounded-full bg-orange-100'>{missionTarget}</p>
                                    <p className='text-gray-600 text-xs mx-1'>{targetGradation}</p>
                                  </div>
                                  <div className='col-span-1 flex justify-start items-center'>
                                    <p className='text-orange-800 text-xs mx-1'>By:</p>
                                    <ClockIcon className='text-lime-600 h-4 w-4' />
                                    <p className='text-gray-800 font-bold text-xs mx-1 px-1 rounded-full bg-orange-100'>{moment(targetDate).format("Do MMM YYYY")}</p>
                                  </div>
                                </div>

                                {showMissionPerf[missionId] && (
                                  <div className='bg-white rounded m-1 p-1'>
                                    <EtPerformanceCard
                                      total={total ?? 0}
                                      completed={completed ?? 0}
                                      rate={rate ?? 0}
                                    />
                                  </div>
                                )}
                              </div>
                            )
                          })}

                          
                       {/* Plan Performance section to be built here - future - 25 Jun 2025 */}






                        {/* <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-2 mt-2 text-[10px] text-gray-700">
                          {focus.missions.map((mission, mIndex) => (
                            <div key={mission.missionId} className="p-2 border rounded bg-gray-50">
                              <p className="font-semibold text-[11px] mb-1">Mission {mIndex + 1}</p>
                              <p>Total: {mission.totalActions}</p>
                              <p>Done: {mission.completedActions}</p>
                              <p>Rate: {mission.completionRate}%</p>

                              {mission.plans?.length > 0 && (
                                <div className="mt-2 border-t pt-1">
                                  {mission.plans.map((plan, pIndex) => (
                                    <div key={plan.planId} className="text-[10px] mt-1 border-b pb-1">
                                      <p className="font-medium">Plan {pIndex + 1}</p>
                                      <p>Total: {plan.totalActions}</p>
                                      <p>Done: {plan.completedActions}</p>
                                      <p>Rate: {plan.completionRate}%</p>
                                    </div>
                                  ))}
                                </div>
                              )}
                            </div>
                          ))}
                        </div> */}
                        </div>
                      )}
                    </div>
                  );
                })()}
              </>
            )}
          </div>
        );
      })()}


    </div>
      
    </div>
  );
}

export default EtTrinityMissionPerformance